<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..."
  type="ball-scale-multiple"></ngx-spinner>
<app-header></app-header>
<div class="container-fluid">
  <div class="upload_row_title">
    KK Upload
  </div>

  <div>
    <!-- <p-fileUpload #form id="newsfeed-upload" name="imageFiles[]" auto="true" mode="advanced" maxFileSize="10000000"
      customUpload="true" (uploadHandler)="uploadPartImg($event, form)" chooseLabel="{{'Choose' | translate}}">
    </p-fileUpload> -->
    <div >
      <input class="form-control" type="file" (change)="onFileChange($event)" #kkfileUpload>
      <label class="uploadKK" (click)="onKKUpload()">
          <i class="fa fa-upload" aria-hidden="true"></i>
          Upload</label>
          <label class="cancelUploadKK" (click)="onCancel()">Cancel</label> 
    </div>
  </div>
  <div>{{'RECOMMENDED_TO_UPLOAD_FILE' | translate}} </div>

  <div class="recentupload_row_title">Recently Uploaded Files Details</div>
  <table  class="table table-bordered table-hover">
      <thead style="background: lightgrey;">
        <tr>
          <th scope="col">Sl. No.</th>
          <th scope="col">File</th>
          <th scope="col">Uploaded By</th>
          <th scope="col">Uploaded Date</th>
          <th scope="col">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of tableKKDataSource; let i=index">
          <td>
           {{i+1}}
          </td>
          <td>
            <a href="{{item.uri+saas_uri}}">{{item.fileName}}</a>
          </td>
          <td>{{item.uploadedBy}}</td>
          <td>{{item.uploadedDate}}</td>
          <td>{{getStatus(item.status)}}</td>
        </tr>
      </tbody>
    </table>
  </div>